module.exports = __webpack_public_path__ + "static/media/6.21_preview.5996f11b.png";